import { ReactNode } from 'react'
import { css } from '@emotion/react'

import Footer from '@/components/Footer'
import Navbar from '@/components/NavigationMenu/Navbar'
import ButtonToTop from '@/components/common/ButtonToTop'

import FooterMobile from '@/components/FooterMobile'

import { useIsMobile } from '@/utils/useMobile'

import PopupOverlayView from '@/components/Popups/PopupOverlayView'
import { useMarket } from '@/utils/multi-markets/context'

import Spinner from '../../common/SpinnerPage'

const wrapper = css`
  flex: 1 0 auto;
  overflow: hidden;
`

interface Props {
  children: ReactNode
  isLoading?: boolean
  fullPage?: boolean
  isFooter?: boolean
  isButtonTop?: boolean
}

function ResultsPage(props: Props) {
  const {
    children,
    isLoading = false,
    fullPage = false,
    isFooter = true,
    isButtonTop = true
  } = props

  const { isMobile } = useIsMobile()
  const { market } = useMarket()

  return !isLoading ? (
    <>
      <div id="popup-wrapper" />
      <Navbar />
      <main css={wrapper}>{children}</main>
      {isFooter && (isMobile ? <FooterMobile /> : <Footer />)}
      {isButtonTop && <ButtonToTop />}
      <div id="pricing-modal" />
      {market && market == 'pl' && <PopupOverlayView isParkingPopup />}
    </>
  ) : (
    <Spinner fullPage={fullPage} />
  )
}

export default ResultsPage
